import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Fieldset,
  Flex,
  Grid,
  Group,
  Menu,
  Modal,
  Select,
  Table,
  Text,
  TextInput,
  Title,
  Tooltip,
  getDefaultZIndex,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDebouncedValue, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowRight,
  IconCheck,
  IconFileSpreadsheet,
  IconRefresh,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  LoaiGv,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById, isJSON } from "../../../_base/helper/FunctionHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  TblDeliveryCreate,
  TblDeliveryCreateV2,
} from "../../../model/TblDeliveryCreate";
import {
  getCommuneSelectNew,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";
import ImportProductExcelView from "./ImportProductExcelView";

const CreateDataViewV2 = ({
  department,
  onSuccess,
}: {
  department: string;
  onSuccess: any;
}) => {
  const [customerSearch, setCustomerSearch] = useState<string>("");
  const [debounceCustomerSearch] = useDebouncedValue<string>(
    customerSearch,
    300
  );
  const [dataCustomer, setDataCustomer] = useState<any[]>([]);
  // Khách hàng đã được chọn (từ danh sách gợi ý hoặc từ đơn hàng): không mở lại dropdown gợi ý
  const [customerPicked, setCustomerPicked] = useState(false);
  const [dataBranch, setDataBranch] = useState<any[]>([]);
  const [dataProvinceSelect, setDataProvinceSelect] = useState<any[]>([]);
  const [dataCommuneSelect, setDataCommuneSelect] = useState<any[]>([]);
  const [productSearch, setProductSearch] = useState<string>("");
  const [debounceProductSearch] = useDebouncedValue<string>(productSearch, 300);
  const [listProduct, setListProduct] = useState<any[]>([]);
  const [listProductCallApi, setListProductCallApi] = useState<any[]>([]);
  const [itemCodeSelect, setItemCodeSelect] = useState<Set<any>>(new Set());
  const [searchOrder, setSearchOrder] = useState<string>("");

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [pagination, setPagination] = useState(paginationBase);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "attribute2",
        header: "Mã sản phẩm",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute5",
        header: "Serial",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.original.attribute4 === "HANG_HACOM"
              ? row.original.attribute5
              : null}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "productName",
        header: "Tên sản phẩm",
        Cell: ({ row }) => (
          <Box w={350}>
            <Tooltip label={row.original.productName}>
              <Text size="12.5px" fw={500} truncate="end" h={15}>
                {row.original.productName}
              </Text>
            </Tooltip>
          </Box>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute3",
        header: "Đơn vị tính",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 50,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={() => {
                  handleDeleteProduct(row.index);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [listProduct]
  );

  const entity = {
    id: 0,
    assignmentDate: null,
    finishDate: null,
    orderHeaderId: 1,
    statusId: null,
    sourceCode: null,
    sourceType: 3,
    description: null,
    isDraft: null,
    printedNumber: null,
    confirmationDate: null,
    fromDeliveryDate: null,
    toDeliveryDate: null,
    method: null,
    branchId: null,
    type: null,
    depId: null,
    returnReason: null,
    customerAddress: null,
    customerProvinceId: null,
    customerDistrictId: null,
    customerCommuneId: null,
    streetId: null,
    fromAddress: null,
    toAddress: null,
    lastUpdateDate: null,
    createBy: null,
    createDate: new Date(),
    lastUpdateBy: null,
    parentId: null,
    priorityId: null,
    customerId: null,
    telephoneNumber: null,
    transactionNumber: null,
    transactionContent: null,
    deliveryAppointmentTime: new Date(),
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
    attribute15: department,
    tblDeliveryDetailCommands: null,
  };

  const form = useForm<TblDeliveryCreateV2>({
    mode: "uncontrolled",
    validateInputOnChange: false,
    initialValues: {
      ...entity,
    },

    validate: {
      attribute15: (value: string | null | undefined) => {
        if (!value) {
          return "Vui lòng chọn bộ phận giao vận !";
        }
      },
      deliveryAppointmentTime: (value: Date | string | null) => {
        if (!value) {
          return "Vui lòng chọn ngày hẹn giao !";
        }
      },
      description: (value: string | null | undefined) => {
        if (!value || String(value).length === 0) {
          return "Vui lòng nhập nội dung giao !";
        }
      },
      telephoneNumber: (value: string | null) => {
        if (value && value.length !== 10) {
          return "Số điện thoại không đúng định dạng !";
        }
      },
      branchId: (value: number | null | string) => {
        if (!value || String(value).length === 0) {
          return "Vui lòng nhập địa điểm giao hàng !";
        }
      },
      customerProvinceId: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tỉnh/thành phố !";
        }
      },
      customerCommuneId: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập phường/xã !";
        }
      },
    },
  });

  const handleSelectProduct = (listData: any, index: number) => {
    setListProduct((prev) => [
      ...prev,
      {
        id: "0",
        orderHeaderId: null,
        orderDetailId: null,
        deliveryQuantity: 1,
        cancelledQuantity: null,
        shippedQuantity: null,
        productName: listData[index].tenSp,
        lastUpdateDate: null,
        createBy: null,
        createDate: null,
        lastUpdateBy: null,
        deliveryId: null,
        attribute5: listData[index].maBarcode,
        attribute2: listData[index].maSp,
        attribute3: listData[index].dvt,
        attribute4: "HANG_HACOM",
      },
    ]);
  };

  // Hộp import excel sản phẩm: Modal tự quản, không dùng modals.open vì modals.open chỉ hiện modal mới nhất,
  // gỡ modal tạo đơn này ra nên import xong danh sách sản phẩm và form bị dựng lại trống
  const [importOpened, { open: openImport, close: closeImport }] = useDisclosure(false);

  /** Nối các dòng import từ excel vào danh sách, đánh dấu serial hàng Hacom đã chọn */
  const handleImportedProducts = (items: any[]) => {
    setListProduct((prev) => [...prev, ...items]);
    setItemCodeSelect((prev) => {
      const newSet = new Set(prev);
      items.forEach((item) => {
        if (item.attribute4 === "HANG_HACOM" && item.attribute5)
          newSet.add(item.attribute5);
      });
      return newSet;
    });
  };

  const handleAddProduct = () => {
    setListProduct((prev) => [
      ...prev,
      {
        id: "0",
        orderHeaderId: null,
        orderDetailId: null,
        deliveryQuantity: 1,
        cancelledQuantity: null,
        shippedQuantity: null,
        productName: productSearch,
        lastUpdateDate: null,
        createBy: null,
        createDate: null,
        lastUpdateBy: null,
        deliveryId: null,
        attribute5: `${Math.floor(100000 + Math.random() * 900000)}`,
        attribute2: null,
        attribute3: null,
        attribute4: "HANG_NGOAI",
      },
    ]);
    setProductSearch("");
  };

  const handleDeleteProduct = (index: number) => {
    const serial = listProduct[index]?.attribute5?.toString();

    // Dòng lấy từ đơn hàng không có serial, vẫn phải xoá được
    if (serial) {
      setItemCodeSelect((prev) => {
        const newSet = new Set(prev);
        if (newSet.has(serial)) {
          newSet.delete(serial);
        }
        return newSet;
      });
    }
    setListProduct((prevData) => prevData.filter((_, i) => i !== index));
  };

  const getCreate = async () => {
    const dataResponse = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDelivery/create?prefix=GH-"
    );
    if (dataResponse?.success) {
      const data = dataResponse.data;
      form.setFieldValue("transactionNumber", data.transactionNumber);
    }
  };

  const fetchDataCustomer = async () => {
    let url = `?Skip=0&Take=${20}`;

    if (customerSearch) {
      url += `&KeySearch=${customerSearch.trim()}`;
    }

    try {
      const res = await repositoryPos.get(
        `api/v1/TblDmCustomer/get-customer-for-delivery${url}`
      );
      if (res && res.success) {
        const data = res.data.lists
          ?.filter((i: any) => i.customerCode && i.customerName)
          ?.map((i: any) => ({
            value: String(i.customerId),
            label: `${i.customerName} - ${i.customerCode}`,
          }));
        setDataCustomer(data);
      }
    } catch (error) {
      setDataCustomer([]);
      return;
    }
  };

  const getDataBranch = async () => {
    const res = await repositoryDelivery.get("/api/v1/TblDmMasterOrg/get-all");

    if (res && res.success) {
      const data = res.data;
      setDataBranch(data);
    }
  };

  const getDataProvinceSelect = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceSelect(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          }))
      );
    }
  };

  const getDataCommuneSelect = async (id: string) => {
    const res = await getCommuneSelectNew(id);

    if (res) {
      setDataCommuneSelect(
        res
          ?.filter((item: any) => item.text && item.value)
          ?.map((item: any) => ({
            value: String(item.value),
            label: String(item.text),
          }))
      );
    }
  };

  const getDataItem = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblInventorySerialOnHand/get-list?KeySearch=${debounceProductSearch}&Take=15`
    );

    if (res && res?.success) {
      const result = res.data;
      setListProductCallApi(result);
    } else {
      setListProductCallApi([]);
    }
  };

  const getDataOrder = async () => {
    form.reset();
    getCreate();
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/CreateSellItem/details?orderNumber=${searchOrder}`
    );

    if (res && res.success) {
      const result = res.data;

      if (result.orderHeader.attribute1?.includes("deliveryAppointmentTime")) {
        const dataShip = isJSON(result.orderHeader.attribute1)
          ? JSON.parse(result.orderHeader.attribute1)
          : result.orderHeader.attribute1;
        const dataProductOrder = result?.orderDetail;

        if (dataProductOrder) {
          const dataSet = dataProductOrder.map((i: any) => ({
            id: i.itemId,
            orderHeaderId: null,
            orderDetailId: null,
            deliveryQuantity: 1,
            cancelledQuantity: null,
            shippedQuantity: null,
            productName: i.itemName,
            lastUpdateDate: null,
            createBy: null,
            createDate: null,
            lastUpdateBy: null,
            deliveryId: null,
            attribute5: null,
            attribute2: i.itemCode,
            attribute3: i.primaryUomCode,
            attribute4: "HANG_HACOM",
          }));
          setListProduct(dataSet);
        }

        if (dataShip) {
          const brandId =
            result?.orderHeader.orgId?.toString() ??
            result?.orderHeader.invOrgId?.toString();
          form.setValues((prev) => ({
            ...prev,
            deliveryAppointmentTime: dataShip.deliveryAppointmentTime
              ? new Date(dataShip.deliveryAppointmentTime)
              : null,
            description: dataShip.description,
            telephoneNumber: dataShip.telephoneNumber,
            customerProvinceId: dataShip.customerProvinceId,
            customerCommuneId: dataShip.customerCommuneId,
            customerAddress: dataShip.customerAddress,
            attribute3: dataShip.customerAddress,
            customerName: dataShip.customerName,
            customerId: dataShip.customerId,
            branchId: brandId,
            fromAddress: dataBranch.find(
              (i: any) => String(i.id) === String(brandId)
            )?.address,
            depId: null,
            sourceType: 1,
            orderHeaderId: result.orderHeader.id,
            sourceCode: result.orderHeader.orderNumber,
          }));

          try {
            let url = `?Skip=0&Take=${10}`;

            if (dataShip.customerId) {
              url += `&KeySearch=${dataShip.customerId}`;
            }
            const response = await repositoryPos.get(
              `api/v1/TblDmCustomer/get-customer-for-delivery${url}`
            );
            if (response && response.success) {
              const data = response.data.lists;
              const filteredData = data
                .filter(
                  (customer: any) =>
                    customer.customerCode && customer.customerName
                )
                .map((item: any) => ({
                  value: item.customerId.toString(),
                  label: `${item.customerName} - ${item.customerCode}`,
                }));
              setDataCustomer(filteredData);
              setCustomerSearch(
                filteredData
                  .find(
                    (x: any) => String(x.value) === String(dataShip.customerId)
                  )
                  .label.split(" - ")[0]
              );
              setCustomerPicked(true);
            }
          } catch (error) {
            setDataCustomer([]);
            return;
          }
        }
      } else {
        const brandId =
          result?.orderHeader.orgId?.toString() ??
          result?.orderHeader.invOrgId?.toString();
        const dataProductOrder = result?.orderDetail;

        if (dataProductOrder) {
          const dataSet = dataProductOrder.map((i: any) => ({
            id: i.itemId,
            orderHeaderId: null,
            orderDetailId: null,
            deliveryQuantity: 1,
            cancelledQuantity: null,
            shippedQuantity: null,
            productName: i.itemName,
            lastUpdateDate: null,
            createBy: null,
            createDate: null,
            lastUpdateBy: null,
            deliveryId: null,
            attribute5: null,
            attribute2: i.itemCode,
            attribute3: i.primaryUomCode,
            attribute4: "HANG_HACOM",
          }));
          setListProduct(dataSet);
        }

        try {
          let url = `?Skip=0&Take=${10}`;

          if (result.orderHeader.custId) {
            url += `&KeySearch=${result.orderHeader.custId}`;
          }
          const response = await repositoryMdm.get(
            `api/v1/TblDmCustomer/get-list${url}`
          );
          if (response && response.success) {
            const custttt = response.data.find(
              (x: any) => x.id === result.orderHeader.custId
            );
            if (custttt) {
              form.setValues((prev) => ({
                ...prev,
                deliveryAppointmentTime: new Date(),
                telephoneNumber: custttt.telephoneNumber,
                customerName: custttt.name,
                attribute7: custttt.name,
                customerId: custttt.id,
                branchId: brandId,
                fromAddress: dataBranch.find(
                  (i: any) => String(i.id) === String(brandId)
                )?.address,
                depId: null,
                sourceType: 1,
                orderHeaderId: res.data.orderHeader.id,
                sourceCode: res.data.orderHeader.orderNumber,
              }));

              const filteredData = response.data;
              const mappedData = filteredData.map((item: any) => ({
                value: item.id,
                label: `${item.name} - ${item.code}`,
              }));
              setDataCustomer(mappedData);
              setCustomerSearch(`${custttt.name} - ${custttt.code}`);
              setCustomerPicked(true);
            }
          }
        } catch (error) {
          setDataCustomer([]);
          return;
        }
      }
    }
  };

  const handleCreateTblDelivery = async (dataSubmit: TblDeliveryCreateV2) => {
    if (
      (!listProduct || listProduct.length === 0) &&
      dataSubmit.sourceType !== 1
    ) {
      NotificationExtension.Fails(
        "Vui lòng điền thông tin sản phẩm cho đơn hàng !"
      );
    } else {
      open();
      try {
        const res = await repositoryDelivery.post<
          MessageResponse<TblDeliveryCreate>
        >("/api/v1/TblDelivery/create-other-delivery", {
          ...dataSubmit,
          toAddress: [
            dataSubmit.attribute3,
            getValueById(
              String(dataSubmit.customerCommuneId),
              dataCommuneSelect,
              "label"
            ),
            getValueById(
              String(dataSubmit.customerProvinceId),
              dataProvinceSelect,
              "label"
            ),
          ]
            .filter((i) => i && i.length > 0)
            .join(" - "),
          tblDeliveryDetailCommands:
            dataSubmit.sourceType !== 1
              ? listProduct && listProduct.length > 0
                ? listProduct.map((i) =>
                    i.attribute4 === "HANG_NGOAI"
                      ? { ...i, attribute5: null }
                      : i
                  )
                : null
              : null,
        });
        if (res && res.success) {
          NotificationExtension.Success("Thêm thành công !");
          setTimeout(() => {
            onSuccess();
            modals.closeAll();
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      } finally {
        close();
      }
    }
  };

  useEffect(() => {
    Promise.all([getCreate(), getDataBranch(), getDataProvinceSelect()]);
  }, []);

  useEffect(() => {
    // Tên vừa được gán sau khi chọn khách / lấy đơn thì không tìm gợi ý lại
    if (customerPicked) return;
    if (debounceCustomerSearch && debounceCustomerSearch.trim().length > 2) {
      fetchDataCustomer();
    } else {
      setDataCustomer([]);
    }
  }, [debounceCustomerSearch]);

  useEffect(() => {
    if (debounceProductSearch && debounceProductSearch.length > 2) {
      getDataItem();
    } else {
      setListProductCallApi([]);
    }
  }, [debounceProductSearch]);

  useEffect(() => {
    if (
      form.getValues().customerProvinceId &&
      String(form.getValues().customerProvinceId).length > 0
    ) {
      getDataCommuneSelect(form.getValues().customerProvinceId || "");
    }
  }, [form.getValues().customerProvinceId]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (600 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data: listProduct,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "transactionNumber"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    //   onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount: listProduct.length,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      pagination,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      //  showRowsPerPage: true,
      withEdges: true,
      //  rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box
      component="form"
      onSubmit={form.onSubmit((e: TblDeliveryCreateV2) => {
        if (!form.isValid) {
          NotificationExtension.Fails("Vui lòng nhập đủ thông tin !");
        } else handleCreateTblDelivery(e);
      })}
    >
      <Group justify="space-between" mt={10}>
        <Badge>Thêm mới đơn giao hàng</Badge>
        <Flex gap={"xs"}>
          <TextInput
            size="sm"
            placeholder="Lấy thông tin đơn hàng"
            value={searchOrder}
            leftSection={<IconSearch size={18} stroke={1.5} />}
            rightSection={
              <ActionIcon
                size={28}
                variant="filled"
                onClick={() => getDataOrder()}
                disabled={searchOrder.length === 0}
              >
                <IconArrowRight size={20} />
              </ActionIcon>
            }
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await getDataOrder();
              }
            }}
            onChange={(e) => setSearchOrder(e.currentTarget.value)}
          />
          <Button
            leftSection={<IconRefresh size={18} />}
            onClick={() => {
              form.reset();
              getCreate();
              setListProduct([]);
              setDataCustomer([]);
              setCustomerSearch("");
              setCustomerPicked(false);
            }}
          >
            Làm mới
          </Button>
          <Button
            type="submit"
            color="teal"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
        </Flex>
      </Group>
      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Grid>
            <Grid.Col span={12}>
              <Fieldset legend="Thông tin đơn hàng" p={"5px 15px 15px 15px"}>
                <Grid>
                  <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                    <TextInput
                      key={form.key("transactionNumber")}
                      label="Số giao dịch"
                      placeholder="Số giao dịch"
                      size="xs"
                      variant="filled"
                      withAsterisk
                      readOnly
                      {...form.getInputProps("transactionNumber")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                    <DatePickerInput
                      key={form.key("createDate")}
                      label="Ngày lập"
                      placeholder="Ngày lập"
                      size="xs"
                      readOnly
                      variant="filled"
                      valueFormat="DD/MM/YYYY"
                      {...form.getInputProps("createDate")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                    <TextInput
                      label="Người lập"
                      placeholder="Người lập"
                      size="xs"
                      variant="filled"
                      readOnly
                      value={
                        JSON.parse(
                          localStorage.getItem("userLoginHeader") || "{}"
                        )?.fullname || ""
                      }
                    />
                  </Grid.Col>
                </Grid>
                <Grid>
                  <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                    <Select
                      key={form.key("attribute15")}
                      label="Bộ phận giao vận"
                      placeholder="Chọn bộ phận giao vận"
                      data={LoaiGv}
                      size="xs"
                      withAsterisk
                      {...form.getInputProps("attribute15")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 8, lg: 8 }}>
                    <TextInput
                      key={form.key("transactionContent")}
                      label="Ghi chú"
                      placeholder={"Nhập ghi chú"}
                      size="xs"
                      {...form.getInputProps("transactionContent")}
                    />
                  </Grid.Col>
                </Grid>
              </Fieldset>
            </Grid.Col>
            <Grid.Col span={12} mt={-5}>
              <Fieldset legend="Thông tin giao hàng" p={"5px 15px 15px 15px"}>
                <Grid>
                  <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                    <DatePickerInput
                      key={form.key("deliveryAppointmentTime")}
                      label="Ngày hẹn giao"
                      placeholder="Chọn ngày hẹn giao"
                      size="xs"
                      valueFormat="DD/MM/YYYY"
                      minDate={new Date()}
                      withAsterisk
                      {...form.getInputProps("deliveryAppointmentTime")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                    <TextInput
                      key={form.key("telephoneNumber")}
                      label="SĐT"
                      placeholder="Nhập số điện thoại"
                      size="xs"
                      type="number"
                      {...form.getInputProps("telephoneNumber")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                    <Menu
                      trigger="click"
                      closeDelay={400}
                      withinPortal
                      opened={
                        !customerPicked &&
                        customerSearch.trim().length >= 3 &&
                        dataCustomer.length > 0
                      }
                    >
                      <Menu.Target>
                        <TextInput
                          label="Khách hàng"
                          placeholder="Nhập mã hoặc tên khách hàng"
                          value={customerSearch}
                          onChange={(e) => {
                            setCustomerSearch(e.currentTarget.value);
                            setCustomerPicked(false);
                            // Lưu tên khách hàng vào attribute7 khi nhập tự do
                            // Set customerId = 0 khi nhập tay
                            form.setValues((prev) => ({
                              ...prev,
                              customerId: 0,
                              attribute7: e.currentTarget.value,
                            }));
                          }}
                          withAsterisk
                          size="xs"
                        />
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Table.ScrollContainer
                          minWidth={180}
                          mah={200}
                          type="native"
                        >
                          <Table highlightOnHover>
                            <Table.Tbody>
                              {dataCustomer && dataCustomer.length > 0 ? (
                                dataCustomer.map((item, index) => (
                                  <Table.Tr key={index}>
                                    <Table.Td
                                      onClick={() => {
                                        form.setValues((prev) => ({
                                          ...prev,
                                          customerId: Number(item.value),
                                          attribute7:
                                            item.label.split(" - ")[0],
                                        }));
                                        setCustomerSearch(
                                          item.label.split(" - ")[0]
                                        );
                                        setCustomerPicked(true);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Text size="xs">{item.label}</Text>
                                    </Table.Td>
                                  </Table.Tr>
                                ))
                              ) : (
                                <Table.Tr>
                                  <Table.Td ta={"center"}>
                                    <Text size="xs" c={"#B5B5CC"}>
                                      {customerSearch?.length < 3
                                        ? "Nhập tối thiểu 3 kí tự"
                                        : "Không tìm thấy dữ liệu !"}
                                    </Text>
                                  </Table.Td>
                                </Table.Tr>
                              )}
                            </Table.Tbody>
                          </Table>
                        </Table.ScrollContainer>
                      </Menu.Dropdown>
                    </Menu>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                    <TextInput
                      key={form.key("attribute7")}
                      label="Tên khách hàng (ngoài)"
                      placeholder="Nhập tên khách hàng"
                      size="xs"
                      type="text"
                      {...form.getInputProps("attribute7")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 8 }}>
                    <TextInput
                      key={form.key("description")}
                      label="Nội dung giao"
                      size="xs"
                      placeholder="Nhập nội dung giao"
                      withAsterisk
                      {...form.getInputProps("description")}
                    />
                  </Grid.Col>
                </Grid>
              </Fieldset>
            </Grid.Col>
            <Grid.Col span={12} mt={-5}>
              <Grid>
                <Grid.Col span={12}>
                  <Fieldset legend="Địa chỉ giao hàng" p={"5px 15px 15px 15px"}>
                    <Grid>
                      <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                        <Select
                          label="Chi nhánh"
                          placeholder="Chọn chi nhánh"
                          size="xs"
                          data={dataBranch
                            .filter((item) => item.id && item.code && item.name)
                            .map((item) => ({
                              label: `${item.code} - ${item.name}`,
                              value: String(item.id),
                            }))}
                          value={
                            form.getValues().branchId &&
                            String(form.getValues().branchId).length > 0
                              ? form.getValues().branchId
                              : null
                          }
                          searchable
                          clearable
                          nothingFoundMessage="Không tìm thấy dữ liệu !"
                          withAsterisk
                          {...form.getInputProps("branchId")}
                          onChange={(e) =>
                            form.setValues((prev) => ({
                              ...prev,
                              branchId: e ? e : null,
                              fromAddress: dataBranch.find(
                                (i: any) => String(i.id) === e
                              )?.address,
                            }))
                          }
                        />
                      </Grid.Col>
                      <Grid.Col span={{ base: 12, md: 12, lg: 8 }}>
                        <TextInput
                          key={form.key("fromAddress")}
                          label="Địa chỉ chi nhánh"
                          placeholder="Địa chỉ chi nhánh"
                          size="xs"
                          variant="filled"
                          readOnly
                          {...form.getInputProps("fromAddress")}
                        />
                      </Grid.Col>
                    </Grid>
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={12} mt={-5}>
                  <Fieldset legend="Địa chỉ nhận hàng">
                    <Grid>
                      <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                        <Select
                          label="Tỉnh/TP"
                          placeholder="Nhập tỉnh/thành phố"
                          data={dataProvinceSelect}
                          value={form.getValues().customerProvinceId}
                          searchable
                          clearable
                          nothingFoundMessage="Không tìm thấy dữ liệu !"
                          size="xs"
                          withAsterisk
                          {...form.getInputProps("customerProvinceId")}
                          onChange={(e) => {
                            form.setValues((prev) => ({
                              ...prev,
                              customerProvinceId: e ? e : null,
                              customerCommuneId: null,
                            }));
                          }}
                        />
                      </Grid.Col>
                      <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                        <Select
                          key={form.key("customerCommuneId")}
                          label="Phường/Xã"
                          placeholder="Nhập phường/xã"
                          data={dataCommuneSelect}
                          disabled={
                            !form.getValues().customerProvinceId ||
                            String(form.getValues().customerProvinceId)
                              .length === 0
                          }
                          searchable
                          clearable
                          nothingFoundMessage="Không tìm thấy dữ liệu !"
                          size="xs"
                          withAsterisk
                          {...form.getInputProps("customerCommuneId")}
                        />
                      </Grid.Col>
                      <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                        <TextInput
                          key={form.key("attribute3")}
                          label="Địa chỉ cụ thể"
                          placeholder="Nhập địa chỉ cụ thể"
                          {...form.getInputProps("attribute3")}
                          size="xs"
                        />
                      </Grid.Col>
                    </Grid>
                  </Fieldset>
                </Grid.Col>
              </Grid>
            </Grid.Col>
          </Grid>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Fieldset legend="Thông tin sản phẩm">
            <Grid>
              <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                <Menu
                  trigger="hover"
                  openDelay={100}
                  closeDelay={400}
                  width={1000}
                >
                  <Menu.Target>
                    <TextInput
                      label="Tên sản phẩm"
                      placeholder="Nhập tên sản phẩm"
                      disabled={form.getValues().sourceType === 1}
                      value={productSearch}
                      onChange={(e) => setProductSearch(e.currentTarget.value)}
                      size="xs"
                    />
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Table.ScrollContainer
                      minWidth={200}
                      mah={300}
                      type="native"
                    >
                      <Table striped withTableBorder>
                        <Table.Thead>
                          <Table.Tr>
                            <Table.Th>Chọn</Table.Th>
                            <Table.Th>Mã sản phẩm</Table.Th>
                            <Table.Th>Serial</Table.Th>
                            <Table.Th>Sản phẩm</Table.Th>
                            <Table.Th>Đơn vị tính</Table.Th>
                          </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                          {listProductCallApi &&
                          listProductCallApi.length > 0 ? (
                            listProductCallApi?.map((item, index) => (
                              <Table.Tr key={index}>
                                <Table.Th>
                                  <Button
                                    variant="filled"
                                    gradient={{
                                      from: "blue",
                                      to: "indigo",
                                      deg: 38,
                                    }}
                                    onClick={() => {
                                      handleSelectProduct(
                                        listProductCallApi,
                                        index
                                      );
                                      setItemCodeSelect((prev) => {
                                        const newSet = new Set(prev);
                                        newSet.add(item.maBarcode);
                                        return newSet;
                                      });
                                    }}
                                    disabled={itemCodeSelect.has(
                                      item.maBarcode
                                    )}
                                    w={90}
                                    h={25}
                                  >
                                    {itemCodeSelect.has(item.maBarcode)
                                      ? "Đã chọn"
                                      : "Chọn"}
                                  </Button>
                                </Table.Th>
                                <Table.Th>{item.maSp}</Table.Th>
                                <Table.Th>{item.maBarcode}</Table.Th>
                                <Table.Th>{item.tenSp}</Table.Th>
                                <Table.Th>{item.dvt}</Table.Th>
                              </Table.Tr>
                            ))
                          ) : (
                            <Table.Tr>
                              <Table.Th colSpan={5} ta={"center"}>
                                {productSearch.length === 0
                                  ? "Hãy nhập mã sản phẩm, serial hoặc tên sản phẩm !"
                                  : "Không tìm thấy sản phẩm !"}
                              </Table.Th>
                            </Table.Tr>
                          )}
                        </Table.Tbody>
                      </Table>
                    </Table.ScrollContainer>
                  </Menu.Dropdown>
                </Menu>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 12, lg: 3 }}>
                <Button
                  size="xs"
                  mt={window.innerWidth > 1200 ? 22 : 0}
                  onClick={handleAddProduct}
                  disabled={
                    productSearch.length === 0 ||
                    form.getValues().sourceType === 1
                  }
                  w={"100%"}
                >
                  Thêm sản phẩm
                </Button>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 12, lg: 3 }}>
                <Button
                  size="xs"
                  mt={window.innerWidth > 1200 ? 22 : 0}
                  variant="outline"
                  leftSection={<IconFileSpreadsheet size={16} />}
                  onClick={openImport}
                  disabled={form.getValues().sourceType === 1}
                  w={"100%"}
                >
                  Import Excel
                </Button>
                <Modal
                  opened={importOpened}
                  onClose={closeImport}
                  title={<Title order={5}>Import excel sản phẩm giao hàng !</Title>}
                  size="auto"
                  yOffset="3%"
                  // Modal tạo đơn do ModalsProvider mở nằm ở z-index modal + 1, phải cao hơn để không bị che
                  zIndex={getDefaultZIndex("modal") + 2}
                >
                  <ImportProductExcelView
                    existingSerials={listProduct
                      .filter((i) => i.attribute4 === "HANG_HACOM" && i.attribute5)
                      .map((i) => String(i.attribute5))}
                    onImported={handleImportedProducts}
                    onClose={closeImport}
                  />
                </Modal>
              </Grid.Col>
            </Grid>
            <Box pt={15}>
              <MantineReactTable table={table} />
            </Box>
          </Fieldset>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default CreateDataViewV2;
